// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Padding only on the sides of the entire component */
.venues-container {
    padding-left: 60px;
    padding-right: 60px;
    margin: 0 auto;
    display: flex;
    flex-direction: column; /* Ensure the content is stacked vertically */
    align-items: center; /* Center everything horizontally */
}

/* Grid layout with explicit vertical and horizontal gap */
.venues-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr); /* 3 columns on large and medium devices */
    column-gap: 30px; /* Horizontal gap */
    row-gap: 25px; /* Vertical gap */
    justify-items: center; /* Ensure the cards are centered */
    margin-bottom: 20px; /* Add space between grid and button */
}

/* Styling for the cards with a lighter gradient background */
.venue-card {
    position: relative;
    overflow: hidden;
    border-radius: 8px;
    transition: none; /* No scaling effect on hover */
    box-shadow: none;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    padding: 20px;
    background: linear-gradient(to top, #f5f8ff 100%, #F7F2FF 100%); /* Lighter gradient from soft gray to light purple */
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); 
    height: 320px; /* Maintain fixed card size */
    width: 100%;
    max-width: 320px;
}

.venue-logo {
    max-width: 80%;
    max-height: 80%;
    object-fit: contain;
    padding: 10px;
}

/* No size change on hover */
.venue-card:hover {
    transform: none; /* Disable hover scaling */
}

/* Updated hover background - darker blue */
.venue-quote {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(30, 40, 150, 0.9); /* Darker blue with more opacity for readability */
    color: white;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    text-align: left;
    opacity: 0;
    transition: opacity 0.3s ease;
    padding: 20px;
    height: 100%;
}

.venue-card:hover .venue-quote {
    opacity: 1;
}

/* Ensure testimonial text fits with space between text and author */
.venue-quote p {
    margin: 0;
    font-size: 0.9em; /* Reduced font size for better fit */
    line-height: 1.5; /* Improve readability */
}

/* Add space between the testimonial and name */
.venue-quote .venue-name {
    margin-top: 15px; /* Adds spacing between the text and the name */
    font-weight: bold;
}

.venue-title {
    font-size: 0.9em;
    margin-top: 5px;
}

/* Read More Button */
.read-more-container {
    text-align: center;
    margin-top: 20px;
}

.read-more-button {
    color:#1d4ed8;
    font-size: 1.2em;
    text-decoration: none;
 
    transition: background-color 0.3s ease, color 0.3s ease;
    display: inline-flex;
    align-items: center;
    padding: 8px 16px;
    border-radius: 4px;
    background: transparent;
}

/* Hover effect for the Read More button */
.read-more-button:hover {
    background-color: #1E40AF; /* Blue background on hover */
    color: white; /* White text on hover */
}

.read-more-button svg {
    margin-left: 5px;
    transition: transform 0.3s ease;
}

.read-more-button:hover svg {
    transform: translateX(5px);
}

/* Responsive design */

/* Adjust to 2x2 grid on mobile devices */
@media (max-width: 768px) {
    .venues-grid {
        grid-template-columns: repeat(2, 1fr); /* 2 columns on mobile */
        column-gap: 20px;
        row-gap: 20px; /* Maintain equal gap */
        justify-items: center; /* Ensure center alignment */
    }
}

/* Adjust to 1x1 grid on smaller screens like extra-small mobile */
@media (max-width: 480px) {
    .venues-grid {
        grid-template-columns: 1fr; /* 1 column on extra-small mobile */
        column-gap: 20px;
        row-gap: 20px; /* Maintain equal gap */
        justify-items: center; /* Ensure center alignment */
    }
}
`, "",{"version":3,"sources":["webpack://./src/blocks/VenuesGrid.css"],"names":[],"mappings":"AAAA,sDAAsD;AACtD;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,sBAAsB,EAAE,6CAA6C;IACrE,mBAAmB,EAAE,mCAAmC;AAC5D;;AAEA,0DAA0D;AAC1D;IACI,aAAa;IACb,qCAAqC,EAAE,0CAA0C;IACjF,gBAAgB,EAAE,mBAAmB;IACrC,aAAa,EAAE,iBAAiB;IAChC,qBAAqB,EAAE,kCAAkC;IACzD,mBAAmB,EAAE,sCAAsC;AAC/D;;AAEA,6DAA6D;AAC7D;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB,EAAE,+BAA+B;IACjD,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,aAAa;IACb,+DAA+D,EAAE,oDAAoD;IACrH,wCAAwC;IACxC,aAAa,EAAE,6BAA6B;IAC5C,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,aAAa;AACjB;;AAEA,4BAA4B;AAC5B;IACI,eAAe,EAAE,0BAA0B;AAC/C;;AAEA,2CAA2C;AAC3C;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,wCAAwC,EAAE,kDAAkD;IAC5F,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;IAChB,UAAU;IACV,6BAA6B;IAC7B,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA,oEAAoE;AACpE;IACI,SAAS;IACT,gBAAgB,EAAE,qCAAqC;IACvD,gBAAgB,EAAE,wBAAwB;AAC9C;;AAEA,+CAA+C;AAC/C;IACI,gBAAgB,EAAE,+CAA+C;IACjE,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,qBAAqB;;IAErB,uDAAuD;IACvD,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA,0CAA0C;AAC1C;IACI,yBAAyB,EAAE,6BAA6B;IACxD,YAAY,EAAE,wBAAwB;AAC1C;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,sBAAsB;;AAEtB,yCAAyC;AACzC;IACI;QACI,qCAAqC,EAAE,wBAAwB;QAC/D,gBAAgB;QAChB,aAAa,EAAE,uBAAuB;QACtC,qBAAqB,EAAE,4BAA4B;IACvD;AACJ;;AAEA,kEAAkE;AAClE;IACI;QACI,0BAA0B,EAAE,mCAAmC;QAC/D,gBAAgB;QAChB,aAAa,EAAE,uBAAuB;QACtC,qBAAqB,EAAE,4BAA4B;IACvD;AACJ","sourcesContent":["/* Padding only on the sides of the entire component */\n.venues-container {\n    padding-left: 60px;\n    padding-right: 60px;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column; /* Ensure the content is stacked vertically */\n    align-items: center; /* Center everything horizontally */\n}\n\n/* Grid layout with explicit vertical and horizontal gap */\n.venues-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr); /* 3 columns on large and medium devices */\n    column-gap: 30px; /* Horizontal gap */\n    row-gap: 25px; /* Vertical gap */\n    justify-items: center; /* Ensure the cards are centered */\n    margin-bottom: 20px; /* Add space between grid and button */\n}\n\n/* Styling for the cards with a lighter gradient background */\n.venue-card {\n    position: relative;\n    overflow: hidden;\n    border-radius: 8px;\n    transition: none; /* No scaling effect on hover */\n    box-shadow: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-decoration: none;\n    padding: 20px;\n    background: linear-gradient(to top, #f5f8ff 100%, #F7F2FF 100%); /* Lighter gradient from soft gray to light purple */\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); \n    height: 320px; /* Maintain fixed card size */\n    width: 100%;\n    max-width: 320px;\n}\n\n.venue-logo {\n    max-width: 80%;\n    max-height: 80%;\n    object-fit: contain;\n    padding: 10px;\n}\n\n/* No size change on hover */\n.venue-card:hover {\n    transform: none; /* Disable hover scaling */\n}\n\n/* Updated hover background - darker blue */\n.venue-quote {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(30, 40, 150, 0.9); /* Darker blue with more opacity for readability */\n    color: white;\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    flex-direction: column;\n    text-align: left;\n    opacity: 0;\n    transition: opacity 0.3s ease;\n    padding: 20px;\n    height: 100%;\n}\n\n.venue-card:hover .venue-quote {\n    opacity: 1;\n}\n\n/* Ensure testimonial text fits with space between text and author */\n.venue-quote p {\n    margin: 0;\n    font-size: 0.9em; /* Reduced font size for better fit */\n    line-height: 1.5; /* Improve readability */\n}\n\n/* Add space between the testimonial and name */\n.venue-quote .venue-name {\n    margin-top: 15px; /* Adds spacing between the text and the name */\n    font-weight: bold;\n}\n\n.venue-title {\n    font-size: 0.9em;\n    margin-top: 5px;\n}\n\n/* Read More Button */\n.read-more-container {\n    text-align: center;\n    margin-top: 20px;\n}\n\n.read-more-button {\n    color:#1d4ed8;\n    font-size: 1.2em;\n    text-decoration: none;\n \n    transition: background-color 0.3s ease, color 0.3s ease;\n    display: inline-flex;\n    align-items: center;\n    padding: 8px 16px;\n    border-radius: 4px;\n    background: transparent;\n}\n\n/* Hover effect for the Read More button */\n.read-more-button:hover {\n    background-color: #1E40AF; /* Blue background on hover */\n    color: white; /* White text on hover */\n}\n\n.read-more-button svg {\n    margin-left: 5px;\n    transition: transform 0.3s ease;\n}\n\n.read-more-button:hover svg {\n    transform: translateX(5px);\n}\n\n/* Responsive design */\n\n/* Adjust to 2x2 grid on mobile devices */\n@media (max-width: 768px) {\n    .venues-grid {\n        grid-template-columns: repeat(2, 1fr); /* 2 columns on mobile */\n        column-gap: 20px;\n        row-gap: 20px; /* Maintain equal gap */\n        justify-items: center; /* Ensure center alignment */\n    }\n}\n\n/* Adjust to 1x1 grid on smaller screens like extra-small mobile */\n@media (max-width: 480px) {\n    .venues-grid {\n        grid-template-columns: 1fr; /* 1 column on extra-small mobile */\n        column-gap: 20px;\n        row-gap: 20px; /* Maintain equal gap */\n        justify-items: center; /* Ensure center alignment */\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
